// test2573
(2573 && 0);
